import { Action, createReducer, on } from '@ngrx/store';
import { Tabs } from 'src/app/dashboard/components/overview/models/overview.model';

import { MyAdvertisementsState } from '../../models/my-advertisements.model';
import * as MyAdvertisementsActions from '../actions/my-advertisements.actions';

export const initialState: MyAdvertisementsState = {
  currentTab: Tabs.manureOffers,
  totalNumberOfActiveOffers: 0,
  totalNumberOfActiveRequests: 0,
  activeOffersOverviewList: [],
  activeRequestsOverviewList: [],
  closedDealsOffersList: [],
  closedRequestsOverviewList: [],
};

export const myAdvertisementsReducer = createReducer(
  initialState,
  on(MyAdvertisementsActions.switchToMyManureOffers, (state) => ({
    ...state,
    currentTab: Tabs.manureOffers,
  })),
  on(MyAdvertisementsActions.switchToMyManureRequests, (state) => ({
    ...state,
    currentTab: Tabs.manureRequests,
  })),
  on(
    MyAdvertisementsActions.loadActiveOffersSuccess,
    (state, { activeOffersList, totalNumberOfActiveOffers }) => ({
      ...state,
      activeOffersOverviewList: activeOffersList,
      totalNumberOfActiveOffers,
    }),
  ),
  on(MyAdvertisementsActions.loadClosedOffersSuccess, (state, { closedDealsOffersList }) => ({
    ...state,
    closedDealsOffersList,
  })),
  on(
    MyAdvertisementsActions.loadActiveRequestsSuccess,
    (state, { activeRequestsList, totalNumberOfActiveRequests }) => ({
      ...state,
      activeRequestsOverviewList: activeRequestsList,
      totalNumberOfActiveRequests,
    }),
  ),
  on(MyAdvertisementsActions.loadClosedRequestsSuccess, (state, { closedRequestsList }) => ({
    ...state,
    closedRequestsOverviewList: closedRequestsList,
  })),
);

export const myAdvertisementsStateReducer = (
  state: MyAdvertisementsState | undefined,
  action: Action,
) => myAdvertisementsReducer(state, action);
